import { DesignateLeadersAsyncStartStatus } from '@ms/yammer-graphql';

import { LoadingLifecycle, OfficeGroup } from '../types';

export enum DesignateLeadersFromOfficeGroupAsyncStatusState {
  Active = 'Active',
  Completed = 'Completed',
  Failed = 'Failed',
}

export interface DesignateLeadersFromOfficeGroupAsyncResultsFields {
  readonly officeGroupId?: OfficeGroup['id'];
  readonly designateLeadersAsyncTaskId?: string;
  readonly taskStartStatus?: DesignateLeadersAsyncStartStatus;
  readonly state?: DesignateLeadersFromOfficeGroupAsyncStatusState;
  readonly usersAddedCount?: number;
  readonly usersNotAddedCount?: number;
  readonly usersTotalCount?: number;
}

export type DesignateLeadersFromOfficeGroupAsyncResults =
  LoadingLifecycle<DesignateLeadersFromOfficeGroupAsyncResultsFields>;
